interface PageSeoProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export default function PageSeo({ title, description, keywords, canonicalPath, jsonLd }: PageSeoProps) {
  const canonical = `https://byfju.cn${canonicalPath}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="爆料官网" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}